import '.d{display:flex;}.ssr-plugin'
import '.a2{align-items:stretch;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.dj{background:var(--palette-white);}.ssr-plugin'
import '.ay{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ag{max-width:77.5rem;}.ssr-plugin'
import '.fe{justify-content:stretch;}.ssr-plugin'
import '.b5{position:sticky;}.ssr-plugin'
import '.b6{top:0px;}.ssr-plugin'
import '.b7{z-index:10;}.ssr-plugin'
import '.g7{padding-block:1rem;}.ssr-plugin'
import '.g8{height:3rem;}.ssr-plugin'
import '.bn{justify-content:space-between;}.ssr-plugin'
import '.c9{flex-wrap:wrap;}.ssr-plugin'
import '.g9{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.em{margin-top:2rem;}.ssr-plugin'
import '.ga{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d a2 ad e dj"
      >
        <div className="ay d r ad e"
        >
          <div className="ag d e fe b5 b6 b7 dj"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="g7 g8 d bn r c9"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="g9 d e a2 em ga ag"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
